import React from "react";
import Deducer from "../Calcul Tools/Deducer";
// import Exercises from "../../data/InfoRules.json";

// Ce fichier gère la page de calcul des propositions.

const exerciseSandbox = {
  title: "Bac à sable de logique (work in progress)",
  premisses: [
    "p",
    "q",
    "p⊃q",
    "q⊃p",
    "~p",
    // "~q",
    "~~p",
    "p∧q",
    "p⊃q",
    // "q⊃r",
    "p∨q",
    "p⊻q",
    "p≡q",
    "p⊅q",
    // "q⊅p",
    "p↑q",
    "q↓p",
    "(p∧q)∧(p∧r)",
    "~(p∧q)",
    // "~~(p∧q)",
    // "(p∧q)⊃r",
    // "p⊃(q⊃r)",
    // "~(q⊃r)",
    // "~(p⊃q)⊃(q⊃r)",
    // "~(p∧r)",
    // "p∧r",
    // "p≡(q≡r)",
    // "~(p∧~q)",
    // "~(p∨q)",
    // "~(~p∧q)∧~(p∧~q)",
    // "~(pvq)≡(~p∧~q)",
  ],
  conclusion: "",
  meaning: [],
  comment: "",
  rulesImplied: [
    "rep",
    "⊃e",
    "reit",
    "hyp",
    "ex falso",
    "~i",
    "~~e",
    "∧i",
    "∧e",
    "∨i",
    "∨e",
    "∨e'",
    "⊻i",
    "⊻e",
    "⊃i",
    "⊂e",
    "≡i",
    "≡e",
    "≡e'",
    "⊅i",
    "⊅e",
    "⊄e",
    "↑i",
    "↑e",
    "↓i",
    "↓e",
  ],
  doable: "sandbox",
};

const Sandbox = (props) => {
  return (
    <main className="calculus-workspace">
      (Page en construction mais vous pouvez tester si vous voulez)
      {/* <ShowInfoSandbox premissesSent={exerciseSandbox.premisses} /> */}
      <Deducer
        // CalculDesPropositions envoie toutes les données des exercises de calculs propositionnels, à Deducer, qui n'est qu'une sorte de calculette mais sans données personnelles
        pageName="Bac à sable de logique"
        exerciseNumber={0}
        // exerciseData={Exercises}
        // exerciseSolutionData={ExercisesSolution}
        exerciseSandbox={exerciseSandbox}
      />
      {/* <SandboxShowUserRequirements /> */}
    </main>
  );
};

export default Sandbox;

// import React, { Component } from "react";
// // import Exercises from "../../data/Exercises.json";
// import Deducer from "../Calcul Tools/Deducer";
// import InferenceProvider, {
//   InferenceContext,
// } from "../Context/InferenceProvider";
// // import Debugger from "../Debugger";
// // import AppShortcuts from "../AppShortcuts";
// // import { ShortcutManager } from "react-shortcuts";

// // Cette classe est appelée dans Calcul des propositions. Elle affiche la totalité des composants nécessaires à une déduction.
// // Elle réceptionne un exercice et son contenu, et le redistribue à différentes classes et fonctions.
// // Elle réceptionne InferenceContext, qui va véhiculer les infos de chaque nouvelle inférence.
// class Sandbox extends Component {
//   renderDebugger(value) {
//     // let result = "";
//     // if (value.booleansOptionsAboutInferences.boolDebugger) {
//     //   result = <Debugger valueInference={value} />; /* on affiche le debugger */
//     // }
//     // return result;
//   }

//   render() {
//     let SandboxExercise = {
//       title: "Sandbox",
//       premisses: ["p", "p⊃q"],
//       conclusion: "q",
//       meaning: [
//         ["p : Il y a une table", "q : Une table existe"],
//         ["p : La Terre est ronde", "q : La Terre n'est pas plate"],
//         [
//           "p : Les politiciens sont irresponsables politiquement",
//           "q : Je ne devrai pas transférer ma responsabilité politique aux politiciens",
//         ],
//       ],
//       comment: "",
//       rulesImplied: ["rep", "⊃e"],
//       doable: true,
//       sandbox: true,
//     };
//     // let ArrayAllPremisses = [
//     //   "p",
//     //   "q",
//     //   "~p",
//     //   "~q",
//     //   "~~p",
//     //   "p∧q",
//     //   "p⊃q",
//     //   "q⊃r",
//     //   "p∨q",
//     //   "p⊻q",
//     //   "p≡q",
//     //   "p⊅q",
//     //   "q⊅p",
//     //   "p↑q",
//     //   "q↓p",
//     //   "p≡q",
//     //   "(p∧q)∧(p∧r)",
//     //   "~(p∧q)",
//     //   "~~(p∧q)",
//     //   "(p∧q)⊃r",
//     //   "p⊃(q⊃r)",
//     //   "~(q⊃r)",
//     //   "~(p⊃q)⊃(q⊃r)",
//     //   "~(p∧r)",
//     //   "p∧r",
//     //   "p≡(q≡r)",
//     //   "~(p∧~q)",
//     //   "~(p∨q)",
//     //   "~(~p∧q)∧~(p∧~q)",
//     //   "~(pvq)≡(~p∧~q)",
//     // ];

//     return (
//       <InferenceProvider>
//         <InferenceContext.Consumer>
//           {(
//             value // (méga important) on permet à tout ce qui est dans la balise InferenceContext.Consumer, d'avoir accès au state déclaré dans InferenceProvider (pour cela il faut employer la variable value)
//           ) => (
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//               }}
//             >
//               <h3 className="pageTitle">Bac à sable logique</h3>
//               <p style={{ margin: "30px", width: "600px" }}>
//                 (j'ai retiré temporairement le bac à sable logique pour la MAJ
//                 de la nouvelle interface, je le rétablirai plus tard, sa
//                 quantité d'infos n'était pour le moment pas adaptée à la
//                 nouvelle interface)
//               </p>
//               <div className="deducer-workspace" style={{ display: "none" }}>
//                 <Deducer currentExercise={SandboxExercise}></Deducer>
//               </div>
//             </div>
//           )}
//         </InferenceContext.Consumer>
//       </InferenceProvider>
//     );
//   }
// }

// export default Sandbox;



// WEBPACK FOOTER //
// ./src/components/Pages/Sandbox.js